import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation11({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [visibleChars, setVisibleChars] = useState<number[]>([])

  const text = badge.name.toUpperCase()
  const chars = text.split('')

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 200)

    chars.forEach((_, index) => {
      setTimeout(() => {
        setVisibleChars(prev => [...prev, index])
      }, 800 + index * 100)
    })
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes rainbowWave {
          0% { color: #FFF198; transform: translateY(0); }
          25% { color: #fcf5cc; }
          50% { color: #feee80; transform: translateY(-10px); }
          75% { color: #FFF198; }
          100% { color: #fcf5cc; transform: translateY(0); }
        }
        @keyframes slideIn {
          0% { transform: translateY(50px) rotateX(90deg); opacity: 0; }
          100% { transform: translateY(0) rotateX(0deg); opacity: 1; }
        }
        .rainbow-char {
          animation: rainbowWave 2s ease-in-out infinite;
          display: inline-block;
        }
        .slide-in {
          animation: slideIn 0.5s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Badge */}
        <div className={`transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 mb-6">
            <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
          </div>
        </div>

        {/* Texte arc-en-ciel */}
        <div className="text-3xl sm:text-5xl font-black flex">
          {chars.map((char, index) => (
            <span
              key={index}
              className={`rainbow-char ${visibleChars.includes(index) ? 'slide-in' : 'opacity-0'}`}
              style={{
                animationDelay: `${index * 0.15}s`,
                textShadow: '0 0 20px currentColor'
              }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </div>

        <div className={`mt-4 text-lg sm:text-xl text-tessan-cream transition-all duration-500 delay-1000 ${visibleChars.length === chars.length ? 'opacity-100' : 'opacity-0'}`}>
          +{badge.points_awarded} points
        </div>

        <div className={`mt-4 text-tessan-cream/70 text-center max-w-[280px] sm:max-w-xs transition-all duration-500 delay-1200 ${visibleChars.length === chars.length ? 'opacity-100' : 'opacity-0'}`}>
          {badge.description}
        </div>
      </div>
    </AnimationLayout>
  )
}
